import { useRequestLoad } from "../../hooks/useLoadedData";
import { useSmartList } from "../../hooks/useSmartList";
import { ProgramExecution } from "./types";

export const useProgramExecutions = (apiPath: string, programId: number) => {
  const requestLoad = useRequestLoad();

  const data = useSmartList<ProgramExecution>(`${apiPath}/execution`, {
    extraParams: { program_id: programId },
    noLoad: !programId || !requestLoad.isLoadRequested,
    noView: true,
    noCount: true,
    schema: {},
    newRecordDefault: {},
  })

  return {
    ...data,
    requestLoad: requestLoad.requestLoad,
  }
}
